import styled from "styled-components";

export const GamificationModalTitleContainer = styled.div`
  font: 600 1.1875rem/1.6875rem "Inter";
  color: ${({ theme }) => theme.console.pageTitleColor};
  text-align: center;

  margin-bottom: 0.3375rem;
`;
